import { render, staticRenderFns } from "./bar-echarts.vue?vue&type=template&id=1005738e&scoped=true"
import script from "./bar-echarts.vue?vue&type=script&lang=ts"
export * from "./bar-echarts.vue?vue&type=script&lang=ts"
import style0 from "./bar-echarts.vue?vue&type=style&index=0&id=1005738e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1005738e",
  null
  
)

export default component.exports